import { OutfitNamesConstants } from "../../../Constants/OutfitNamesConstants";
import { AABB } from "../../../Utils/AABB";
import { Point } from "../../../Utils/Point";
import { CollisionSubjectModel } from "./CollisionSubjectModel";

export class OutfitCollisionModel extends CollisionSubjectModel {
    public name: OutfitNamesConstants = OutfitNamesConstants.Type0;
    public outfitName = 0;
    public billboardName = 0;
    public isCollected = false;

    private _mapSize = {
        [OutfitNamesConstants.Type0]: new Point(100, 230),
        [OutfitNamesConstants.Type1]: new Point(100, 280),
        [OutfitNamesConstants.Type2]: new Point(100, 330),
        [OutfitNamesConstants.Type3]: new Point(100, 380),
        [OutfitNamesConstants.Type4]: new Point(100, 430),
        [OutfitNamesConstants.Type5]: new Point(100, 480),
        [OutfitNamesConstants.Type6]: new Point(100, 530),
        [OutfitNamesConstants.Type7]: new Point(100, 580),
        [OutfitNamesConstants.Type8]: new Point(100, 630),
        [OutfitNamesConstants.Type9]: new Point(100, 680),
    };

    get aabb() {
        const width = 100;
        const height = 100;
        const offsetX = 0.5 * (this.width - width);
        return new AABB(new Point(this.pos.x + offsetX, this.pos.y - this.height - height), new Point(this.pos.x + width + offsetX, this.pos.y - this.height));
    }

    get width() {
        return this._mapSize[this.name].x;
    }

    get height() {
        return this._mapSize[this.name].y;
    }
}